import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import { getAllAllowedOrganisationIds, getOrganisationId } from "../organisations/organisationsSlice";
import StorageService from "../../util/storage";

const token = process.env.REACT_APP_STRAPI_API_TOKEN;
const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    }
});

export const forgetPassword = async (username) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/forget-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: StorageService.getItem("bearer"),
        },
        body: JSON.stringify({ username }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
        // toast("Error! status: " + response.status, { type: "error" });
    }

    return response.json();
};

export const checkIfUserIsPartOfOrganisation = async (username) => {
    const orgIds = await getAllAllowedOrganisationIds();
    const query = gql`
        query getUser($username: String!, $orgIds: [String]!) {
            usersPermissionsUsers(
                filters: { or: [{ username: { eq: $username } }, { user_identifier: { eq: $username } }, { email: { eq: $username } }], organisations: { orgId: { in: $orgIds } } }
            ) {
                data {
                    id
                    attributes {
                        username
                        firstname
                        lastname
                        confirmed
                        isUserApproved
                        blocked
                        organisations {
                            data {
                                id
                                attributes {
                                    orgId
                                }
                            }
                        }
                    }
                }
            }
        }
    `;

    const { data } = await client.query({
        query,
        variables: { username, orgIds },
    });
    return data.usersPermissionsUsers.data.length > 0 ? data.usersPermissionsUsers.data[0] : null;
};

export const fetchUser = async (id) => {
    const query = gql`
        query getUser($id: ID!) {
            usersPermissionsUser(id: $id) {
                data {
                    id
                    attributes {
                        username
                        user_identifier
                        email
                        firstname
                        lastname
                        phone
                        confirmed
                        isUserApproved
                        blocked
                        organisations {
                            data {
                                id
                                attributes {
                                    orgId
                                }
                            }
                        }
                        DriverAuthorityID
                        memberNetwork {
                            data {
                                id
                                attributes {
                                    name
                                    isBlocked
                                    isMember
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { id },
    });
    return data.usersPermissionsUser.data;
};

export const fetchUserByUsername = async (identifier) => {
    const query = gql`
        query getUser($identifier: String!) {
            usersPermissionsUsers(filters: { or: [{ username: { eq: $identifier } }, { email: { eq: $identifier } }] }) {
                data {
                    id
                    attributes {
                        username
                        email
                        firstname
                        lastname
                        phone
                        confirmed
                        isUserApproved
                        blocked
                        organisations {
                            data {
                                id
                                attributes {
                                    orgId
                                }
                            }
                        }
                        DriverAuthorityID
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { identifier },
    });
    return data.usersPermissionsUsers.data.length > 0 ? data.usersPermissionsUsers.data[0] : null;
};

export const updateUser = async (id, data) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: StorageService.getItem("bearer"),
        },
        body: JSON.stringify(data),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
        // toast("Error! status: " + response.status, { type: "error" });
    }

    return response.json();
};

export const changePassword = async (currentPassword, password, jwtToken) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/change-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: jwtToken,
        },
        body: JSON.stringify({
            currentPassword,
            password,
            passwordConfirmation: password,
        }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
        // toast("Error! status: " + response.status, { type: "error" });
    }

    const { jwt, user } = await response.json();

    StorageService.setItem("token", jwt);
    StorageService.setItem("bearer", `Bearer ${jwt}`);
    StorageService.setItem("user", user);

    return user;
};

export const requestResetPassword = async (email) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, username: email }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
        // toast("Error! status: " + response.status, { type: "error" });
    }

    return response.json();
};

export const completeResetPassword = async ({ code, password, passwordConfirmation }) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code, password, passwordConfirmation }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
        // toast("Error! status: " + response.status, { type: "error" });
    }

    return response.json();
};
